import { ConciliacionesPage } from "@finanedi.es/front-ops"
import { ButtonERP } from "@finanedi.es/storybook"
import { faArrowLeft } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useReglasConciliacionPage } from "./hooks/use-reglas-conciliacion-page"

export const ReglasConciliacion = () => {
  const {
    nifTitular,
    initialTipo,
    handleUpdateTipoParam,
    handleUpdateCuentaIdParam,
    handleNavigateToForm,
    handleBack,
  } = useReglasConciliacionPage()
  return (
    <ConciliacionesPage
      nifTitular={nifTitular ?? ""}
      backComponent={
        <ButtonERP
          customize={{
            type: "white",
            size: "md",
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={handleBack}
        />
      }
      onUpdateTipoParam={handleUpdateTipoParam}
      initialTipo={initialTipo}
      handleNavigateToForm={handleNavigateToForm}
      handleUpdateCuentaIdParam={handleUpdateCuentaIdParam}
    />
  )
}
